// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("/tmp/4de6a246/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-product-js": () => import("/tmp/4de6a246/src/templates/product.js" /* webpackChunkName: "component---src-templates-product-js" */),
  "component---src-pages-blog-js": () => import("/tmp/4de6a246/src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-index-js": () => import("/tmp/4de6a246/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

